// extracted by mini-css-extract-plugin
module.exports = {"renderer":"ContentRenderer_renderer__tPJbs","body":"ContentRenderer_body__XLXHl"};